import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Container, Box } from '@mui/material';

// Components
import KULSHeader from './KULSHeader';
import KULSSidebar from './KULSSidebar';

// Pages
import KULSDashboard from '../pages/KULSDashboard';
import KULSTransactions from '../pages/KULSTransactions';
import KULSMyBlocks from '../pages/KULSMyBlocks';
import KULSMyInfo from '../pages/KULSMyInfo';
import PartnerIntegrationPrototype from '../pages/PartnerIntegrationPrototype';

// 📌 단순화: 전역 폴링 제거

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

interface KULSMainProps {
  user: UserInfo;
  onLogout: () => void;
}

function KULSMain({ user, onLogout }: KULSMainProps) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const isIntegrationPrototype = location.pathname === '/integration-prototype';

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    // 📌 단순화: PollingProvider 제거
    <Box sx={{ display: 'flex' }}>
        <KULSHeader 
          user={user}
          onMenuClick={toggleSidebar} 
          onLogout={onLogout} 
        />
        <KULSSidebar 
          open={sidebarOpen} 
          onClose={() => setSidebarOpen(false)} 
        />
        <Container 
          component="main" 
          maxWidth={isIntegrationPrototype ? false : 'xl'}
          disableGutters={isIntegrationPrototype}
          sx={{ 
            flexGrow: 1, 
            minWidth: 0,
            padding: isIntegrationPrototype ? 0 : '24px',
            marginTop: 9,  // Header height adjustment
            marginLeft: isIntegrationPrototype ? { xs: 1, md: 2 } : sidebarOpen ? 15 : 8,  // Sidebar state optimization
            marginRight: isIntegrationPrototype ? { xs: 1, md: 2 } : 8,  // Right margin
            transition: 'margin-left 0.3s ease'
          }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<KULSDashboard user={user} />} />
            <Route path="/transactions" element={<KULSTransactions user={user} />} />
            <Route path="/blocks" element={<KULSMyBlocks user={user} />} />
            <Route path="/my-blocks" element={<Navigate to="/blocks" replace />} />
            <Route path="/integration-prototype" element={<PartnerIntegrationPrototype partner="KULS" user={user} />} />
            <Route path="/my-info" element={<KULSMyInfo user={user} />} />
            <Route path="/info" element={<Navigate to="/my-info" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Container>
      </Box>
  );
}

export default KULSMain;
